export const colors = {
  '--black': '#000000',
  '--dark-text': '#171717',
  '--dark-background-black': '#0C131F',
  '--link-blue': '#0000FF',
  '--tagline-blue': '#0DA6FF',
  '--tag-blue': '#00D5FF',
  '--gray': '#EBEEF2',
  '--green': '#4DBF86',
  '--border-gradient-first-blue': '#0000FF',
  '--border-gradient-last-blue': '#0DA6FF',
  '--tag-gray': '#a6a6a6',
  '--underlined-gray': '#464646',
  '--overlay-background-blue': 'rgba(13, 166, 255, 0.85)', // same as --border-gradient-last-blue with different opacity
};

export const fontWeights = {
  '--light': 300,
  '--regular': 400,
  '--medium': 500,
  '--semi-bold': 600,
  '--bold': 700,
};

export const fontSizes = {
  '--m-page-title': '28px',
  '--m-page-subtitle': '20px',
  '--m-section-title': '21px',
  '--m-list-title': '28px',
  '--m-list-description': '20px',
  '--page-title': '3vw',
  '--page-subtitle': '2vw',
};

export const sizes = {
  '--section-height': '52.25vw', /* 16:9 aspect */
  '--horizontal-margin': '15vw',
  '--m-horizontal-margin': '30px',
  '--vertical-margin': '8%',
  '--m-vertical-margin': '80px',
  '--button-border-size': '2px',
};

const cssVariables = {
  ...colors,
  ...fontWeights,
  ...fontSizes,
  ...sizes,
};

export default cssVariables;
